import React from 'react';

interface ContentTextProps {
  children: React.ReactNode;
  className?: string;
}

export const ContentHeading1: React.FC<ContentTextProps> = ({ children, className = '' }) => {
  return (
    <h1 className={`content-heading ${className}`}>
      {children}
    </h1>
  );
};

export const ContentHeading2: React.FC<ContentTextProps> = ({ children, className = '' }) => {
  return (
    <h2 className={`content-heading ${className}`}>
      {children}
    </h2>
  );
};

export const ContentHeading3: React.FC<ContentTextProps> = ({ children, className = '' }) => {
  return (
    <h3 className={`content-heading ${className}`}>
      {children}
    </h3>
  );
};

export const ContentText: React.FC<ContentTextProps> = ({ children, className = '' }) => {
  return (
    <p className={`content-text ${className}`}>
      {children}
    </p>
  );
};

export const ContentWrapper: React.FC<ContentTextProps> = ({ children, className = '' }) => {
  return (
    <div className={`content-area ${className}`}>
      {children}
    </div>
  );
};
